import {PublisherParameter} from '../../widget-base/data/publisher-parameter';
import {DataRow} from '../../../DoraData/data-row';

export class RowToSubscribe {
  private dataRow: DataRow;
  private publisherParameters: PublisherParameter[] = [];


  constructor(dataRow: DataRow, publisherParameters: PublisherParameter[]) {
    this.dataRow = dataRow;
    this.publisherParameters = publisherParameters;
  }

  get DataRow(): DataRow {
    return this.dataRow;
  }

  get PublisherParameters(): PublisherParameter[] {
    return this.publisherParameters;
  }
}
